// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as OrderRepoConfig from "./OrderRepoConfig.bs.js";
import * as ApiUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";

var dummyResponse = {
    order_list: [
      {
        order_fare: 297,
        order_id: "CRN00000000",
        pickup_time: "2018-12-21 19:26:31 +0530",
        status: "completed",
      },
      {
        order_fare: 296,
        order_id: "CRN00000000",
        pickup_time: "2018-12-25 19:26:31 +0530",
        status: "completed",
      },
    ],
    };

function fetchOrders_old(_msisdn, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(OrderRepoConfig.OrderListResponseConverter.execute, result);
                        });
            });
}

var dummyPageOrderInfo = {
      "offset" : 1588005557991,
      "total_count": 18,
      "orders":[
      {
         "order_id":"CRN00000000",
         "source":"android",
         "customer":{
            "uuid":"00000000-0000-0000-0000-00000000000",
            "mobile":"0000000000",
            "first_name":"TEST",
            "last_name":"TEST",
            "insti_with_contracted_engagement":false
         },
         "driver":{
            "value":{
               "msisdn":"0000000000000",
               "name":"Kebri"
            }
         },
         "from_address_landmark":"Aakruthi Silverline",
         "to_address_landmark":"Big Pitcher",
         "created_at_millis":1646507316000,
         "pickup_time_millis": 1646507316000,
         "vehicle_type":"Tata Ace",
         "status":"completed",
         "order_type":"spot",
         "brand":"porter"
      },
      {
         "order_id":"CRN00000000",
         "source":"website",
         "customer":{
            "uuid":"00000000-0000-0000-0000-00000000000",
            "mobile":"0000000000",
            "first_name":"TEST",
            "last_name":"TEST",
            "insti_with_contracted_engagement":false
         },
         "driver":{
            "value":{
               "msisdn":"0000000000000",
               "name":"Kebri"
            }
         },
         "from_address_landmark":"Aakruthi Silverline",
         "to_address_landmark":"Big Pitcher, LR Arcade, 4121/P",
         "created_at_millis":1646507316000,
         "pickup_time_millis": 1646507316000,
         "vehicle_type":"Tata Ace",
         "status":"completed",
         "order_type":"spot",
         "brand":"porter"
      },
      {
         "order_id":"CRN00000000",
         "source":"ondc",
         "customer":{
            "uuid":"00000000-0000-0000-0000-00000000000",
            "mobile":"0000000000",
            "first_name":"TEST",
            "last_name":"TEST",
            "insti_with_contracted_engagement":false
         },
         "driver":{
            "value":{
               "msisdn":"0000000000000",
               "name":"Kebri"
            }
         },
         "from_address_landmark":"Aakruthi Silverline",
         "to_address_landmark":"Big Pitche",
         "created_at_millis":1646507316000,
         "pickup_time_millis": 1646507316000,
         "vehicle_type":"Tata Ace",
         "status":"completed",
         "order_type":"spot",
         "brand":"porter"
      },
      {
         "order_id":"CRN00000000",
         "source":"android",
         "customer":{
            "uuid":"00000000-0000-0000-0000-00000000000",
            "mobile":"0000000000",
            "first_name":"TEST",
            "last_name":"TEST",
            "insti_with_contracted_engagement":false
         },
         "driver":{
            "value":{
               "msisdn":"0000000000000",
               "name":"Kebri"
            }
         },
         "from_address_landmark":"Aakruthi Silverline",
         "to_address_landmark":"Big Pitcher",
         "created_at_millis":1646507316000,
         "pickup_time_millis": 1646507316000,
         "vehicle_type":"Tata Ace",
         "status":"cancelled",
         "order_type":"spot",
         "brand":"porter"
      },
      {
         "order_id":"CRN00000000",
         "source":"android",
         "customer":{
            "uuid":"00000000-0000-0000-0000-00000000000",
            "mobile":"0000000000",
            "first_name":"TEST",
            "last_name":"TEST",
            "insti_with_contracted_engagement":false
         },
         "driver":{
            "value":{
               "msisdn":"0000000000000",
               "name":"Kebri"
            }
         },
         "from_address_landmark":"Aakruthi Silverline",
         "to_address_landmark":"Big Pitcher",
         "created_at_millis":1646507316000,
         "pickup_time_millis": 1646507316000,
         "vehicle_type":"Tata Ace",
         "status":"cancelled",
         "order_type":"spot",
         "brand":"porter"
      },
      {
         "order_id":"CRN00000000",
         "source":"android",
         "customer":{
            "uuid":"00000000-0000-0000-0000-00000000000",
            "mobile":"0000000000",
            "first_name":"TEST",
            "last_name":"TEST",
            "insti_with_contracted_engagement":false
         },
         "driver":{

         },
         "from_address_landmark":"27th Main, Old Madiwala, Jay Bheema Nagr",
         "to_address_landmark":"Big Pitcher",
         "created_at_millis":1646507316000,
         "pickup_time_millis": 1646507316000,
         "vehicle_type":"Tata Ace",
         "status":"cancelled",
         "order_type":"spot",
         "brand":"porter"
      },
      {
         "order_id":"CRN00000000",
         "source":"android",
         "customer":{
            "uuid":"00000000-0000-0000-0000-00000000000",
            "mobile":"0000000000",
            "first_name":"TEST",
            "last_name":"TEST",
            "insti_with_contracted_engagement":false
         },
         "driver":{

         },
         "from_address_landmark":"Aakruthi Silverline",
         "to_address_landmark":"Big Pitcher",
         "created_at_millis":1646507316000,
         "pickup_time_millis": 1646507316000,
         "vehicle_type":"Tata Ace",
         "status":"cancelled",
         "order_type":"spot",
         "brand":"porter"
      },
      {
         "order_id":"CRN00000000",
         "source":"ios",
         "customer":{
            "uuid":"00000000-0000-0000-0000-00000000000",
            "mobile":"0000000000",
            "first_name":"test",
            "last_name":"test",
            "insti_with_contracted_engagement":false
         },
         "driver":{

         },
         "from_address_landmark":"318, 22nd Main Rd",
         "to_address_landmark":"38, Mahayogi Vemana Road",
         "created_at_millis":1646507316000,
         "pickup_time_millis": 1646507316000,
         "vehicle_type":"Ace Helper",
         "status":"cancelled",
         "order_type":"spot",
         "brand":"porter"
      },
      {
         "order_id":"CRN00000000",
         "source":"android",
         "customer":{
            "uuid":"00000000-0000-0000-0000-00000000000",
            "mobile":"0000000000",
            "first_name":"TEST",
            "last_name":"TEST",
            "insti_with_contracted_engagement":false
         },
         "driver":{

         },
         "from_address_landmark":"Aakruthi Silverline",
         "to_address_landmark":"Big Pitcher",
         "created_at_millis":1646507316000,
         "pickup_time_millis": 1646507316000,
         "vehicle_type":"Tata Ace",
         "status":"cancelled",
         "order_type":"spot",
         "brand":"porter"
      },
      {
         "order_id":"CRN00000000",
         "source":"android",
         "customer":{
            "uuid":"00000000-0000-0000-0000-00000000000",
            "mobile":"0000000000",
            "first_name":"TEST",
            "last_name":"TEST",
            "insti_with_contracted_engagement":false
         },
         "driver":{

         },
         "from_address_landmark":"Aakruthi Silverline",
         "to_address_landmark":"Big Pitcher",
         "created_at_millis":1646507316000,
         "pickup_time_millis": 1646507316000,
         "vehicle_type":"Tata Ace",
         "status":"cancelled",
         "order_type":"spot",
         "brand":"porter"
      },
      {
         "order_id":"CRN00000000",
         "source":"android",
         "customer":{
            "uuid":"00000000-0000-0000-0000-00000000000",
            "mobile":"0000000000",
            "first_name":"Sanity 5.14.0",
            "last_name":"Test Shilpa",
            "insti_with_contracted_engagement":false
         },
         "driver":{
            "value":{
               "msisdn":"00000000000000",
               "name":"shilpa testing"
            }
         },
         "from_address_landmark":"97, Kalidasa Layout",
         "to_address_landmark":"BTM Layout, Bengaluru, Karnataka, India",
         "created_at_millis":1646507316000,
         "pickup_time_millis": 1646507316000,
         "vehicle_type":"Tata Ace",
         "status":"completed",
         "order_type":"spot",
         "brand":"porter"
      },
      {
         "order_id":"CRN00000000",
         "source":"android",
         "customer":{
            "uuid":"00000000-0000-0000-0000-00000000000",
            "mobile":"0000000000",
            "first_name":"TEST",
            "last_name":"TEST",
            "insti_with_contracted_engagement":false
         },
         "driver":{

         },
         "from_address_landmark":"Aakruthi Silverline",
         "to_address_landmark":"Big Pitcher",
         "created_at_millis":1646507316000,
         "pickup_time_millis": 1646507316000,
         "vehicle_type":"Tata Ace",
         "status":"cancelled",
         "order_type":"spot",
         "brand":"porter"
      },
      {
         "order_id":"CRN00000000",
         "source":"android",
         "customer":{
            "uuid":"00000000-0000-0000-0000-00000000000",
            "mobile":"0000000000",
            "first_name":"TEST",
            "last_name":"TEST",
            "insti_with_contracted_engagement":false
         },
         "driver":{

         },
         "from_address_landmark":"Aakruthi Silverline",
         "to_address_landmark":"Big Pitcher",
         "created_at_millis":1646507316000,
         "pickup_time_millis": 1646507316000,
         "vehicle_type":"Tata Ace",
         "status":"cancelled",
         "order_type":"spot",
         "brand":"porter"
      },
      {
         "order_id":"CRN00000000",
         "source":"android",
         "customer":{
            "uuid":"00000000-0000-0000-0000-00000000000",
            "mobile":"0000000000",
            "first_name":"TEST",
            "last_name":"TEST",
            "insti_with_contracted_engagement":false
         },
         "driver":{
            "value":{
               "msisdn":"0000000000",
               "name":"Mani's Test Driver"
            }
         },
         "from_address_landmark":"Aakruthi Silverline",
         "to_address_landmark":"Big Pitcher",
         "created_at_millis":1646507316000,
         "pickup_time_millis": 1646507316000,
         "vehicle_type":"Tata Ace",
         "status":"completed",
         "order_type":"spot",
         "brand":"porter"
      },
      {
         "order_id":"CRN00000000",
         "source":"android",
         "customer":{
            "uuid":"00000000-0000-0000-0000-00000000000",
            "mobile":"0000000000",
            "first_name":"TEST",
            "last_name":"TEST",
            "insti_with_contracted_engagement":false
         },
         "driver":{

         },
         "from_address_landmark":"Aakruthi Silverline",
         "to_address_landmark":"Big Pitcher",
         "created_at_millis":1646507316000,
         "pickup_time_millis": 1646507316000,
         "vehicle_type":"Tata Ace",
         "status":"cancelled",
         "order_type":"spot",
         "brand":"porter"
      },
      {
         "order_id":"CRN00000000",
         "source":"android",
         "customer":{
            "uuid":"00000000-0000-0000-0000-00000000000",
            "mobile":"0000000000",
            "first_name":"TEST",
            "last_name":"TEST",
            "insti_with_contracted_engagement":false
         },
         "driver":{

         },
         "from_address_landmark":"Aakruthi Silverline",
         "to_address_landmark":"Big Pitcher",
         "created_at_millis":1646507316000,
         "pickup_time_millis": 1646507316000,
         "vehicle_type":"Tata Ace",
         "status":"cancelled",
         "order_type":"spot",
         "brand":"porter"
      },
      {
         "order_id":"CRN00000000",
         "source":"android",
         "customer":{
            "uuid":"00000000-0000-0000-0000-00000000000",
            "mobile":"0000000000",
            "first_name":"TEST",
            "last_name":"TEST",
            "insti_with_contracted_engagement":false
         },
         "driver":{

         },
         "from_address_landmark":"Aakruthi Silverline",
         "to_address_landmark":"Big Pitcher",
         "created_at_millis":1646507316000,
         "pickup_time_millis": 1646507316000,
         "vehicle_type":"Tata Ace",
         "status":"cancelled",
         "order_type":"spot",
         "brand":"porter"
      },
      {
         "order_id":"CRN00000000",
         "source":"android",
         "customer":{
            "uuid":"00000000-0000-0000-0000-00000000000",
            "mobile":"0000000000",
            "first_name":"TEST",
            "last_name":"TEST",
            "insti_with_contracted_engagement":false
         },
         "driver":{

         },
         "from_address_landmark":"Aakruthi Silverline",
         "to_address_landmark":"Big Pitcher",
         "created_at_millis":1646507316000,
         "pickup_time_millis": 1646507316000,
         "vehicle_type":"Tata Ace",
         "status":"cancelled",
         "order_type":"spot",
         "brand":"porter"
      },
      {
         "order_id":"CRN00000000",
         "source":"android",
         "customer":{
            "uuid":"00000000-0000-0000-0000-00000000000",
            "mobile":"0000000000",
            "first_name":"TEST",
            "last_name":"TEST",
            "insti_with_contracted_engagement":false
         },
         "driver":{

         },
         "from_address_landmark":"Aakruthi Silverline",
         "to_address_landmark":"Big Pitcher",
         "created_at_millis":1646507316000,
         "pickup_time_millis": 1646507316000,
         "vehicle_type":"Tata Ace",
         "status":"cancelled",
         "order_type":"spot",
         "brand":"porter"
      },
      {
         "order_id":"CRN00000000",
         "source":"android",
         "customer":{
            "uuid":"00000000-0000-0000-0000-00000000000",
            "mobile":"0000000000",
            "first_name":"TEST",
            "last_name":"TEST",
            "insti_with_contracted_engagement":false
         },
         "driver":{

         },
         "from_address_landmark":"Aakruthi Silverline",
         "to_address_landmark":"Big Pitcher",
         "created_at_millis":1646507316000,
         "pickup_time_millis": 1646507316000,
         "vehicle_type":"Tata Ace",
         "status":"cancelled",
         "order_type":"spot",
         "brand":"porter"
      }
   ],
    };

function fetchOrders(request, offset, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyPageOrderInfo
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(OrderRepoConfig.FilterOrderResponseConverter.execute, result);
                        });
            });
}

var OrderRepo = {
  fetchOrders_old: fetchOrders_old,
  fetchOrders: fetchOrders
};

export {
  OrderRepo ,
  
}
/* OrderRepoConfig Not a pure module */
